module.exports = __webpack_public_path__ + "img/mtw_hw_token.c1500659.jpg";